import { CustomAxiosRequestConfig } from "../../../../../interceptors/axios/custom-axios";
import { BaseApi } from "../../../../../interceptors/base-axios/base-axios";
import { ENDPOINTS } from "./end-point";

export interface CredentialValidationPayload {
    userName: string;
    password: string;
}

export interface CredentialValidationResponse {
    createdByID: number;
    updatedByID: number;
    internalUser: boolean;
    sso: boolean;
    idmuser: boolean;
    scustNumber: string;
    companyName: string;
    user_ID: string;
    customerID: number;
    addressID: number;
    contactID: number;
    login_ATTEMPTS: number;
    company_ID_SEQ_NUM: number;
    addressPresent: boolean;
    encrypt: boolean;
    companyPresent: boolean;
    IDMUser?: boolean;
    USER_ID?: string;
    LOGIN_ATTEMPTS?: number;
    COMPANY_ID_SEQ_NUM?: number;
    sCustNumber?: string;
    customerId?: number;
    login_attempts?: number;
}

const normalizeCredentialValidationResponse = (responseData: any): CredentialValidationResponse => {
    const payload = responseData?.data ?? responseData ?? {};

    return {
        createdByID: payload.createdByID ?? 0,
        updatedByID: payload.updatedByID ?? 0,
        internalUser: payload.internalUser ?? false,
        sso: payload.sso ?? false,
        idmuser: payload.idmuser ?? payload.IDMUser ?? false,
        scustNumber: payload.scustNumber ?? payload.sCustNumber ?? "",
        companyName: payload.companyName ?? "",
        user_ID: payload.user_ID ?? payload.USER_ID ?? "",
        customerID: payload.customerID ?? payload.customerId ?? 0,
        addressID: payload.addressID ?? 0,
        contactID: payload.contactID ?? 0,
        login_ATTEMPTS: payload.login_ATTEMPTS ?? payload.LOGIN_ATTEMPTS ?? payload.login_attempts ?? 0,
        company_ID_SEQ_NUM: payload.company_ID_SEQ_NUM ?? payload.COMPANY_ID_SEQ_NUM ?? 0,
        addressPresent: payload.addressPresent ?? false,
        encrypt: payload.encrypt ?? false,
        companyPresent: payload.companyPresent ?? false,
        IDMUser: payload.IDMUser ?? payload.idmuser ?? false,
        USER_ID: payload.USER_ID ?? payload.user_ID ?? "",
        LOGIN_ATTEMPTS: payload.LOGIN_ATTEMPTS ?? payload.login_ATTEMPTS ?? payload.login_attempts ?? 0,
        COMPANY_ID_SEQ_NUM: payload.COMPANY_ID_SEQ_NUM ?? payload.company_ID_SEQ_NUM ?? 0,
        sCustNumber: payload.sCustNumber ?? payload.scustNumber ?? "",
        customerId: payload.customerId ?? payload.customerID ?? 0,
        login_attempts: payload.login_attempts ?? payload.LOGIN_ATTEMPTS ?? payload.login_ATTEMPTS ?? 0,
    } as CredentialValidationResponse;
};
export interface AssociateHoneywellIdPayload {
    honeywellId: string;
    customerNumber: string;
    firstName: string;
    lastName: string;
    status: string;
    emailId: string;
    countryCode?: string;
    phoneNumber: string;
    accessStartDate?: string;
    accessEndDate?: string;
    userType: string;
    customerRole?: { roleId: number }[];
    storeFrontId: number;
    storeFront?: string;
}
export interface ValidateRolePayload {
    honeywellId: string;
    roleId?: number;
    storeFrontId: number;
    customerId: number;
    companyName: string;
}
export interface CustomerBasicInfoPayload {
    customerNumber: number;
}

export interface CustomerBasicInfoResponse {
    customerId?: number;
    customerName?: string;
    customerRefSeq?: number;
}
export interface CustomerUsersSearchPayload {
    honeywellOrEmailId: string;
  
}

export interface CustomerUsersSearchResponse {
    email?: string;
    firstname?: string;
    honeywellid?: string;
    lastname?: string;
    customerid?: number;
    customerId?: number;
}

export interface GenerateTokenResponse {
    access_token: string;
    refresh_token: string | null;
    id_token: string | null;
    token_type: string;
    expires_in: number;
}

export const generateToken = async (): Promise<GenerateTokenResponse> => {
    try {
        const response = await BaseApi.baseApiServiceCon.post(ENDPOINTS.generateToken);
        return response.data?.data ?? response.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error.message);
    }
};
export const credentialValidation = async (
    params: CredentialValidationPayload,
    accessToken: string
): Promise<CredentialValidationResponse> => {
    try {
        const headers: any = {
            appName: "INDS",
        };

        if (accessToken) {
            headers.Accesstoken =  accessToken;
        }

        const config: CustomAxiosRequestConfig = {
            headers,
        };
        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.credentialValidation,
            params,
            config,
        );
        return normalizeCredentialValidationResponse(response.data);
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error.message);
    }
};

export const associateHoneywellIdData = async (
    params: AssociateHoneywellIdPayload,
    accessToken: string
): Promise<any> => {
    try {
        const headers: any = {
            appName: "INDS",
        };

        if (accessToken) {
            headers.accessToken =  accessToken;
        }

        const config: CustomAxiosRequestConfig = {
            requiresCSRF: true,
            headers,
        };
        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.associateHoneywellID,
            params,
            config,
        );
        return response.data?.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error.message);
    }
};

export const validateRoleData = async (
    params: ValidateRolePayload,
    accessToken: string
): Promise<any> => {
    try {
        const headers: any = {
            appName: "INDS",
        };

        if (accessToken) {
            headers.Accesstoken = accessToken;
        }

        const config: CustomAxiosRequestConfig = {
            headers,
        };

        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.validateRole,
            params,
            config
        );
        return response.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.detail || error.message);
    }
};

export const getCustomerBasicInfoData = async (
    params: CustomerBasicInfoPayload,
    accessToken: string
): Promise<CustomerBasicInfoResponse> => {
    try {
        const headers: any = {
            appName: "INDS",
        };

        if (accessToken) {
            headers.Accesstoken = accessToken;
        }

        const config: CustomAxiosRequestConfig = {
            headers,
        };

        const response = await BaseApi.baseApiCon.post(
            ENDPOINTS.customerBasicInfo,
            params,
            config
        );
        return response.data?.data ?? response.data;
    } catch (error: any) {
        throw new Error(error?.response?.data?.errorMessage || error?.response?.data?.detail || error.message);
    }
};

export const customerUsersSearch = async (
    params: CustomerUsersSearchPayload,
    accessToken: string
): Promise<CustomerUsersSearchResponse> => {
    try {
        const headers: any = {
            appName: "INDS",
        };

        if (accessToken) {
            headers.Accesstoken = accessToken;
        }

        const config: CustomAxiosRequestConfig = {
            headers,
        };

        const response = await BaseApi.customerBaseUrl.post(
            ENDPOINTS.customerUsersSearch,
            params,
            config
        );
        return response.data?.data ;

    } catch (error: any) {
        throw new Error(error?.response?.data?.error?.errorMessage || error?.response?.data?.error?.detail);
    }
};



